var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoRequirements(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.24,
    height: 35.24,
    viewBox: "0 0 35.24 35.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_69893",
    "data-name": "Raggruppa 69893",
    transform: "translate(-688.444 -2566.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_69875",
    "data-name": "Raggruppa 69875",
    transform: "translate(693.43 2571.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M2330.074,1292.76a12.7,12.7,0,0,1-5.956-1.484.874.874,0,0,1,.823-1.542,10.977,10.977,0,0,0,7.622,1,.874.874,0,0,1,.4,1.7A12.744,12.744,0,0,1,2330.074,1292.76Z",
    transform: "translate(-2317.466 -1267.437)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    d: "M2321.616,1289.076a.871.871,0,0,1-.6-.24,12.631,12.631,0,0,1-3.6-6.2.874.874,0,0,1,1.7-.411,10.879,10.879,0,0,0,3.1,5.341.874.874,0,0,1-.6,1.51Z",
    transform: "translate(-2317.114 -1266.983)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    d: "M2317.977,1278.883h-.087a.874.874,0,0,1-.789-.952v-.008a12.549,12.549,0,0,1,1.12-4.078.874.874,0,1,1,1.584.738,10.824,10.824,0,0,0-.961,3.512A.874.874,0,0,1,2317.977,1278.883Z",
    transform: "translate(-2317.097 -1266.52)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    d: "M2321.861,1271.251a.874.874,0,0,1-.675-1.428c.078-.1.157-.189.238-.281a.875.875,0,1,1,1.322,1.148h0c-.07.079-.138.161-.2.243A.876.876,0,0,1,2321.861,1271.251Z",
    transform: "translate(-2317.316 -1266.29)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    d: "M2336.451,1289.77a.874.874,0,0,1-.45-1.624,10.915,10.915,0,0,0-5.6-20.284.874.874,0,1,1,0-1.748,12.662,12.662,0,0,1,6.495,23.531A.87.87,0,0,1,2336.451,1289.77Z",
    transform: "translate(-2317.797 -1266.114)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    d: "M2336.014,1278.35h-5v-5h-1.756v5h-5v1.752h5v5h1.752v-5h5Z",
    transform: "translate(-2317.5 -1266.521)",
    fill: "#d1d1d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_69864",
    "data-name": "Raggruppa 69864",
    transform: "translate(683.444 1609.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37382",
    "data-name": "Tracciato 37382",
    d: "M22.62,5A17.62,17.62,0,1,0,40.24,22.62,17.638,17.638,0,0,0,22.62,5Zm0,2.349a15.274,15.274,0,0,1,11.6,25.206L12.684,11.02A15.217,15.217,0,0,1,22.62,7.349ZM11.032,12.684,32.556,34.207A15.263,15.263,0,0,1,11.032,12.684Z",
    transform: "translate(0 952.362)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRequirements);
export default __webpack_public_path__ + "static/media/no-requirements.1ba1835aa518228b216cb09853bc6614.svg";
export { ForwardRef as ReactComponent };